export enum FortressErrorMessage {
  InvalidPhoneNumber = "Error in 'Phone': 'Phone' is not valid",
  InvalidCardName = 'Legal name and card name are not the same.',
  IncompleteCardDetails = 'Incomplete card details.',
  ExpiredCard = "Expiration Month' must be greater than or equal to '6'.",
  DuplicateSSN = 'The Identity with ssn already exists in current organization',
  DuplicateCard = 'Conflict',
  DuplicateEmail = 'The Identity with email already exists in current organization',
  InvalidCreditCardNumber = "Number' is not a valid card number",
  DuplicatePhoneNumber = 'The Identity with phone already exists in current organization',
  InvalidEIN = "The specified condition was not met for 'Ein'",
}

export enum RiseUpErrors {
  DuplicatePhoneNumber = 'A record with the same phoneNumber already exists.',
  DuplicateSSN = 'A record with the same ssn already exists.',
  LimitCreateTrade = 'Investor can only create new investment after time has passed',
  ExternalAccountIsLinked = 'HttpException: This account already has a linked external account',
}

export enum GeneralErrors {
  InvalidOnboardingGroupLink = 'Onboarding Group Link is invalid',
}

export enum ErrorMessages {
  DuplicatePhoneNumber = "There's a duplicate phone number in the system. Please enter a unique phone number.",
  InvalidCardName = 'Legal name and card name should be the same.',
  IncompleteCardDetails = 'Please fill the remaining fields for card details.',
  ExpiredCard = 'Your card might be expired. Please enter valid card details.',
  DuplicateSSN = "There's a duplicate Social Security number in the system. Please enter a unique Social Security number.",
  DuplicateCard = "There's a duplicate Credit Card number in the system. Please enter a unique Credit Card number.",
  DuplicateEmail = "There's a duplicate Email in the system. Please enter a unique email.",
  InvalidCreditCardNumber = 'Your Credit Card is not valid. Please enter a valid Credit Card.',
  DuplicatePhoneNumber2 = "There's a duplicate phone number in the system. Please enter a unique phone number.",
  InvalidEIN = 'EIN provided is not valid.',
  InvalidOnboardingGroupLink = 'Your onboarding link is invalid. Please use a valid onboarding link.',
  LimitCreateTrade = 'Investor can only create new investment after time has passed.',
  ExternalAccountIsLinked = 'You already have linked an external account.',
}
